module.exports = __webpack_public_path__ + "assets/d9366fa3f646776c3e0de812eb505990.png";